import { Flex } from '@chakra-ui/react'
import { MotionBox, barVariants } from './animations'

interface AnimatedProgressBarProps {
  percentage: number
  bgColor?: string
  metricKey?: string
}

export const AnimatedProgressBar = ({ percentage, bgColor = 'primary.500', metricKey }: AnimatedProgressBarProps) => {
  const animationKey = metricKey ? `${metricKey}-${percentage}` : `${percentage}`
  
  return (
    <Flex flexGrow={1} position="relative">
      <MotionBox
        key={`bg-${animationKey}`}
        bg='gray.100'
        height="10px"
        borderRadius="5px"
        minW="2px"
        custom={{ percentage: 100, delay: 0 }}
        variants={barVariants}
        initial="hidden"
        animate="visible"
        position="absolute"
        left={0}
      />
      <MotionBox
        key={`bar-${animationKey}`}
        bg={bgColor}
        height="10px"
        borderRadius="5px"
        minW="2px"
        variants={barVariants}
        custom={{ percentage, delay: 0.3 }}
        initial="hidden"
        animate="visible"
        zIndex={1}
      />
    </Flex>
  )
}
